import React from "react";
import { motion } from "framer-motion";
import { fadeUp } from "../../lib/motion";

export default function PreHeadline() {
  return (
    <section data-testid="pre-packages-section" className="py-24 sm:py-32">
      <div className="max-w-4xl mx-auto px-6 sm:px-8 text-center">
        <motion.div {...fadeUp}>
          <p className="overline mb-10">— Where It Begins</p>
          <p className="font-serif-display text-[color:var(--charcoal)] text-3xl sm:text-5xl leading-[1.15] tracking-tight font-medium">
            Information isn't the problem.
            <br />
            <span className="italic text-[color:var(--gold)]">Structure is.</span>
          </p>
          <div className="mx-auto my-12 w-12 h-px bg-[color:var(--gold)]" />
          <p className="font-serif-display italic text-xl sm:text-2xl text-[color:var(--text-secondary)]">
            Three ways to have it done properly.
          </p>
        </motion.div>
      </div>
    </section>
  );
}
